import ListingType from './listing-type';
var ListingUseType;
(function (ListingUseType) {
  ListingUseType["RESIDENTIAL"] = "residential";
  ListingUseType["COMMERCIAL"] = "commercial";
  ListingUseType["BUSINESS"] = "business";
})(ListingUseType || (ListingUseType = {}));
var getListingUseType = listingType => {
  if (!listingType) {
    return undefined;
  }
  if (listingType.name === ListingType.SALES_BUSINESS.name) {
    return ListingUseType.BUSINESS;
  }
  return listingType.isCommercial ? ListingUseType.COMMERCIAL : ListingUseType.RESIDENTIAL;
};
export default ListingUseType;
export { getListingUseType };